export default "__VITE_ASSET__D8fbXfA8__"